(function () {
    'ngInject';

    angular.module('app.shared.services').factory('OpenAIAPIService', openAIAPIService);

    function openAIAPIService(HttpService) {
        const baseURL = 'https://api.openai.com';
        const imageToImageURL = `${baseURL}/v1/images/edits`;

        const imageToImageBackendUrl = '/api/OpenAi/ImageToImage';

        function isValidAPIKey(key) {
            //TODO: Validate key when user enters it.
        }

        async function textToImage(username, typedText) {
            const baseApiUrl =
                process.env.VUE_APP_CUSTOMILY_STOREFRONT_SERVICE_API_URL ||
                'https://app.customily.com/service/storefront';
            var myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');

            var raw = JSON.stringify({
                prompt: typedText,
                user: username
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            try {
                const url = new URL(`${baseApiUrl}/text-to-image-generator-openai/generate`);
                const response = await fetch(url.toString(), requestOptions);
                if (!response.ok) {
                    throw new Error(`Request failed with status ${response.status} ${response.statusText}`);
                }

                const result = await response.json();
                if (!result.base64) {
                    throw new Error('Image generation response did not include image data.');
                }

                return `data:image/webp;base64,${result.base64}`;
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        async function imageToImageOnBackendServer(username, imageFile, config) {
            const { prompt, quality, size, background } = config;

            const formData = new FormData();
            formData.append('username', username);
            formData.append('prompt', prompt);
            if (quality) formData.append('quality', quality);
            if (size) formData.append('size', size);
            if (background) formData.append('background', background);
            formData.append('image', imageFile);

            try {
                const response = await fetch(imageToImageBackendUrl, {
                    method: 'POST',
                    body: formData
                });
                return await response.json();
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        async function imageToImage(key, image, prompt) {
            var myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + key);

            const form = new FormData();
            form.append('model', 'gpt-image-1');
            form.append('prompt', prompt);
            form.append('n', 1);
            form.append('size', 'auto');
            form.append('quality', 'low');
            form.append('image', image);

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: form,
                redirect: 'follow'
            };

            try {
                const response = await fetch(imageToImageURL, requestOptions);
                if (!response.ok) {
                    throw new Error(`Request failed with status ${response.status} ${response.statusText}`);
                }

                const result = await response.text();
                return result;
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        return {
            textToImage,
            imageToImage,
            imageToImageOnBackendServer
        };
    }
})();
